/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SummarizationsControllerFindOneQueryResponse, SummarizationsControllerFindOnePathParams, SummarizationsControllerFindOneQueryParams, SummarizationsControllerFindOne400, SummarizationsControllerFindOne401, SummarizationsControllerFindOne403, SummarizationsControllerFindOne404 } from "../../models/documentSummariesController/SummarizationsControllerFindOne";

function getSummarizationsControllerFindOneUrl(documentId: SummarizationsControllerFindOnePathParams["documentId"], renditionId: SummarizationsControllerFindOnePathParams["renditionId"], summaryId: SummarizationsControllerFindOnePathParams["summaryId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/summaries/${summaryId}` as const }  
  return res
}

/**
 * @description Returns detailed information about a specific summary
 * @summary Get a specific summary
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/summaries/:summaryId}
 */
export async function summarizationsControllerFindOne(documentId: SummarizationsControllerFindOnePathParams["documentId"], renditionId: SummarizationsControllerFindOnePathParams["renditionId"], summaryId: SummarizationsControllerFindOnePathParams["summaryId"], params?: SummarizationsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SummarizationsControllerFindOneQueryResponse, ResponseErrorConfig<SummarizationsControllerFindOne400 | SummarizationsControllerFindOne401 | SummarizationsControllerFindOne403 | SummarizationsControllerFindOne404>, unknown>({ method : "GET", url : getSummarizationsControllerFindOneUrl(documentId, renditionId, summaryId).url.toString(), params, ... requestConfig })  
  return res.data
}